import { useCallback, useState } from 'react';

const useSmartFieldsToggle = ({ currentData, onToggleSmartFields }) => {
    const [showConfirmModal, setShowConfirmModal] = useState(false);

    const handleConfirm = useCallback(() => {
        onToggleSmartFields({
            ...currentData,
            smartFields: [],
            dynamicFieldValues: null,
            useSmartFields: true,
        });
        setShowConfirmModal(false);
    }, [currentData, onToggleSmartFields]);

    const handleCancelConfirm = useCallback(() => {
        setShowConfirmModal(false);
    }, []);

    const handleToggle = useCallback(
        (newValue) => {
            if (newValue) {
                // Enabling SmartFields
                if (currentData?.dynamicFieldValues && currentData.dynamicFieldValues.length > 0) {
                    // Show confirmation modal
                    setShowConfirmModal(true);
                } else {
                    // No existing dynamicFieldValues, just initialize empty array
                    onToggleSmartFields({
                        ...currentData,
                        smartFields: [],
                        dynamicFieldValues: null,
                        useSmartFields: true,
                    });
                }
            } else {
                // Disabling SmartFields
                onToggleSmartFields({
                    ...currentData,
                    smartFields: [],
                    useSmartFields: false,
                });
            }
        },
        [currentData, onToggleSmartFields],
    );

    return {
        showConfirmModal,
        handleToggle,
        handleConfirm,
        handleCancelConfirm,
    };
};

export default useSmartFieldsToggle;
